import type { ConfigRouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, type CursorPaginationRailsParams, apiClient, routes } from 'common/services';
import type { GlobalSearchResultItemDataObject } from 'models/service';

type GlobalSearchQueryParams = { query?: string } & CursorPaginationRailsParams;
type GlobalSearchRouteParams = { scope: string };

export const getGlobalSearchResults = async ({
  config: { params },
  routeParams: { scope },
}: ConfigRouteParamsRequest<GlobalSearchQueryParams, GlobalSearchRouteParams>) =>
  apiClient.get<GlobalSearchResultItemDataObject[], ApiClientResponse<GlobalSearchResultItemDataObject[]>>(
    routes.globalSearch.get(scope),
    { params },
  );
